<script>
  //import "material-design-icons"

  let projects = [
    {
      publicViewing: true,
      name: "XiYi - 習易",
      discription:
        "Svelte project development in progress. The goal is to help I Ching (Book of Changes, 易經) learners to practice the skills. Target release: March 2021.",
    },
    {
      publicViewing: true,
      name: "Cloudidi",
      discription:
        "Demo site in Svelte (this site). I put a few simple components here for public viewing. I also use the site to experiment new features before I put them into the real projects.",
    },
    {
      publicViewing: true,
      name: "Vue/VuePress sites",
      discription:
        "The previous version of the cloudidi was done in VuePress. I also developed a few simple sites in Vue (ex. teen coding school, media delivery site)",
    },
    {
      publicViewing: true,
      name: "REACT site",
      discription:
        "(offline) The first implementation of the teen coding school site was done in REACT with NoSQL in mlab.",
    },
    {
      publicViewing: true,
      name: "Full stack (PHP, Javascript, MySQL)",
      discription:
        "A process automation internal Web site for the PM office that supported more than 400 users.",
    },
    {
      publicViewing: true,
      name: "Microsoft Office VBS",
      discription: "For data analysis and workflow automation",
    },
    {
      publicViewing: true,
      name: "HTML documentation generation",
      discription:
        "Convert product manual into HTML. Integrated online manual and products for production",
    },
    {
      publicViewing: true,
      name: "Auto SQL query generation",
      discription:
        "Developed the auto SQL generation and query features for silicon image simulation data analysis",
    },
    {
      publicViewing: true,
      name: "Std cell library characterization automation in Python",
      discription:
        "ASIC standard cell libraries HPSICE simulation and characterization work flow. The project included the testbench, test vector generation and automation control",
    },
    {
      publicViewing: true,
      name: "PCI Verilog simulation model and testbench generator",
      discription:
        "The project was written in C++. It was to automatically create the Verilog PCI testbench with corresponding test vectors and checks.",
    },
    {
      publicViewing: true,
      name: "ASIC RTL design in Verilog",
      discription:
        "I participated a graphic accellerator project and designed the memory address mapping block. The design was awarded with US Patent: 5745739",
    },
    {
      publicViewing: true,
      name: "Unix system programming in C/C++/shell scripts",
      discription:
        "Many of these throw-away programs/scripts were for various of projects at work",
    },
    {
      publicViewing: true,
      name: "Diagnostic and device driver (written in C++).",
      discription:
        "The project was to implement SCSI disk diagnostic tests for a database computer project.",
    },
    {
      publicViewing: true,
      name: "Boundary scan circuit and testbench generator",
      discription:
        "Boundary scan circuit and testbench VHDL model generator (written in C).",
    },
  ]
</script>

<main>
  <h4>About Cloudidi</h4>
  <p>
    This site is just for experiments. Once a component is working, I will adapt
    it in my other projects. The site has been going through many evolutions.
    The previous implementation was done with VuePress. I started this new
    implementation using Svelte and Materialize CSS since 1/27/2021.
  </p>

  <h5>Me</h5>
  <p>
    My name is Erh-Chiao Wang. I like to learn and always find ideas to try out.
    On the backend side, I used PHP and Python before. With Netlify, AWS S3,
    etc., I think front-end stack with some serverless functions will do just
    fine for most projects.
  </p>
  <p>
    On the front-end side, I tried Angular 1 as it just started out and hated
    it. Then I did a small site using REACT, moving on to Vue on a few things.
    As of January 2021, I really like Svelte and feel it set me free.
  </p>

  <p>
    Prior getting into Web-related projects, all my projects were developing
    software or developing software to generate simulation models and circuit
    designs.
  </p>

  <h5>Projects & Programming Experiences</h5>
  <p>
    For all my projects, I pick a language or a set of languages and
    technologies to solve the problem. So far, I have used C/C++, Python, Ruby,
    all sort of Unix shell scripting languages and utilities, SQL, JSON, PHP,
    Javascripts, HTML/CSS/md, MS VBS, etc. How to best sovling the problems
    should be the focus, the language and technologies are just tools to use for
    solving problems.
  </p>
  <div>
    <ul class="list">
      {#each projects as project}
        <li class="waves-effect">
          <div class="valign-wrapper">
            <img src="./images/code-24px.svg" alt="code" />&nbsp;&nbsp;
            <div class="title">
              <strong>{project.name} :</strong>
              {project.discription}
            </div>
          </div>
          <!-- <div style="display=none;">{(even = !even)}</div> -->
        </li>
      {/each}
    </ul>
  </div>

  <h5>Sandbox</h5>
  <p>
    I have a small brain and have to do content-swapping all the times. The
    Sandbox area is where I unload some components from various projects and
    experiements for future refereces. I put some of those little features in
    the <a href="/sandbox"> Sandbox</a>.
  </p>

  <h5>Route</h5>
  <p>
    The routing is implemented using page.js and Svelte store. Good enough for
    this little demo site.
  </p>

  <h5>Technologies Used</h5>
  <p>Svelte, CSS, HTML, Gitlab, Netlify, Google Firebase auth and db.</p>

  <h5>About Login</h5>
  <p>
    Login is just for myself. Some components in the Sandbox are only viewable
    by me (need loging in).
  </p>

  <h5>To-Do's</h5>
  <p>
    When I have time, I will put a few more components in the Sandbox for public
    viewing.
  </p>
</main>

<style>
  body {
    background-color: #f2f2f2;
    letter-spacing: 0.25px;
  }

  .container {
    margin-top: 30px;
    max-width: 500px;
  }

  .card {
    overflow: auto;
  }

  .waves-effect {
    width: 100%;
  }

  .subheader {
    font-size: 1rem;
    font-weight: 500;
    line-height: 1.5rem;
    margin: 0.75rem 16px;
  }

  .list-divider {
    border: 0;
    height: 1px;
    overflow: hidden;
    background-color: #e0e0e0;
    margin-right: 16px;
    margin-left: 75px;
  }

  .list {
    margin: 0;
  }

  .list li {
    padding: 0 16px;
  }

  .list li .valign-wrapper {
    min-height: 62px;
  }
  .list li:nth-child(odd) .valign-wrapper {
    /* min-height: 50px; */
    background-color: rgba(196, 159, 57, 0.26);
  }

  .list i.circle {
    padding: 10px;
    background-color: rgba(0, 0, 0, 0.26);
  }

  .list .title span {
    color: rgba(0, 0, 0, 0.54);
  }

  .ml-auto {
    margin-left: auto;
  }

  i.ml-auto {
    color: rgba(0, 0, 0, 0.26);
  }
</style>
